import { render } from "./Mentions.vue?vue&type=template&id=ded16d2c"
import script from "./Mentions.vue?vue&type=script&lang=js"
export * from "./Mentions.vue?vue&type=script&lang=js"

import "./Mentions.vue?vue&type=style&index=0&id=ded16d2c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__